/**
 * Employee Row Component for AssigneePickerPopover
 * Extracted from AssigneePickerPopover.tsx
 */

import { memo } from 'react';
import type { Employee, TeamDefinition } from '../../../types';

export const EmployeeRow = memo(function EmployeeRow({
  employee,
  team,
  isAssigned,
  disabled,
  onClick,
}: {
  employee: Employee;
  team?: TeamDefinition;
  isAssigned: boolean;
  disabled?: boolean;
  onClick?: () => void;
}) {
  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        width: '100%',
        padding: '6px 6px 6px 6px',
        fontSize: 14,
        color: '#1f2937',
        textAlign: 'left',
        backgroundColor: 'transparent',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.4 : 1,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = isAssigned ? '#fef2f2' : '#eff6ff';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
    >
      {/* Checkmark or empty space */}
      <span style={{ width: 16, flexShrink: 0 }}>
        {isAssigned && (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </span>

      {/* Color dot */}
      <span
        style={{ width: 12, height: 12, borderRadius: '50%', flexShrink: 0, backgroundColor: employee.color }}
      />

      {/* Name */}
      <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#1f2937' }}>{employee.name}</span>

      {/* Skills */}
      {employee.skills && (
        <span style={{ fontSize: 12, flexShrink: 0, color: '#6b7280' }} title={employee.skills}>
          {employee.skills.slice(0, 8)}
        </span>
      )}

      {/* Team Badge */}
      {team && (
        <span
          style={{
            padding: '2px 6px',
            borderRadius: 4,
            fontSize: 10,
            fontWeight: 500,
            flexShrink: 0,
            backgroundColor: `${team.color}20`,
            color: team.color,
          }}
        >
          {team.name}
        </span>
      )}
    </button>
  );
});
